export const FETCH_SOURCEGROUP = 'FETCH_SOURCEGROUP';
export const FETCH_SOURCEGROUP_SUCCESS = 'FETCH_SOURCEGROUP_SUCCESS';

export const fetchSourceGroup = (data) => ({
  type: FETCH_SOURCEGROUP,
  data
});

export const fetchSourceGroupSuccess = (data) => ({
  type: FETCH_SOURCEGROUP_SUCCESS,
  data,
});



/** WEBPACK FOOTER **
 ** ./src/app/modules/sourceGroup/actions.js
 **/